<div class="modal-menu">
  <div class="inner">
    <button
      mat-button
      [disabled]="item.disabled"
      *ngFor="let item of list"
      (click)="select(item.value)"
      class="button"
    >
      {{ item.label }}
    </button>
    <button mat-button (click)="cancel()" class="button -cancel">{{ cancelLabel }}</button>
  </div>
</div>
